/*
    Archivo: assets/p-variant-picker-card.js 
*/
import { CartAddEvent } from '@theme/events';

class CardVariantPickers {
    constructor(element) {
        this.element = element;
        const productDataElement = this.element.querySelector('script[type="application/json"][p-product-data]');
        if (!productDataElement) {
            console.error('Product data not found!');
            return;
        }
        this.product = JSON.parse(productDataElement.textContent); 
        this.variants = this.product.variants;   
        this.card = this.element.closest('.p-card') || null;
        this.variantIdInput = this.element.querySelector('input[name="id"]');
        this.atcButton = this.element.querySelector('button[type="submit"]');
        this.init();
    }

    init() {
        // console.log('CardVariantPickers init', this.element);
        this.attachOption1Listeners();
        this.attachOption2Listeners();
        this.form = this.element;
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        
    }
 
    // CTA enabled/disabled - cada cambio de variante. Si el click es en option2 añade al carrito. 
    onOptionChanged(addToCart) {
        setTimeout(() => {
            const selectedVariant = this.getSelectedVariant();    
            if (selectedVariant) {
                this.doEveryVariantChange(selectedVariant)
                if (selectedVariant.available) {
                    this.enableAtc();
                    if (addToCart) {
                        clg("this.atcButton.click();")
                        this.atcButton.click();
                    }
                } else {
                    this.disableAtc()
                }
            } else {
                this.disableAtc();
            }
        }, 100);
    }
    enableAtc(){
        this.atcButton.disabled = false;
        this.atcButton.classList.remove('is-disabled');
    }
    disableAtc(){
        this.atcButton.disabled = true;
        this.atcButton.classList.add('is-disabled');
    }
    getSelectedVariant(){
        const inputs = this.element.querySelectorAll('input[type="radio"]:checked');
        const selectedValues = [];
        inputs.forEach(input => {
            const position = parseInt(input.dataset.pangoOptionPosition, 10);
            const value = input.dataset.pangoOptionValue;
            selectedValues[position - 1] = value;
        });

        const selectedVariant = this.variants.find(variant =>
            variant.options.every((opt, i) => selectedValues[i] === undefined || opt === selectedValues[i])
        );
        return selectedVariant;
    }

    doEveryVariantChange(selectedVariant){
        console.log("dentro doEveryVariantChange - Selected variant ID", selectedVariant.id);
        this.variantIdInput.value = selectedVariant.id;  // actualizamos Variant Id del form input
        this.updateCardLinks(selectedVariant); 
        this.updatePrice(selectedVariant)
        this.updateOption1Legend()
    }
    attachOption1Listeners() {
        const inputs = this.element.querySelectorAll('[data-pango-option-position="1"]');
        inputs.forEach(input => {
            input.addEventListener('click', () => {
                // console.log("click on option 1")
                this.preloadOption1CardImages();
                this.onOptionChanged();
                this.updateOption2Values();
                this.updateCardImages()  
            });
        });
    } 
    attachOption2Listeners() {
        const inputs =  this.element.querySelectorAll('[data-pango-option-position="2"]');
        inputs.forEach(input => {
            input.addEventListener('change', () => {
                // console.log("click on option 2")  
                let addToCart = true;              
                this.onOptionChanged(addToCart);
            });
        });
    } 

    // Actualiza precio 
    updatePrice(selectedVariant) {          
        const priceContainer = this.card.querySelector('[p-info-price]');
        if (!priceContainer) return;

        const price = selectedVariant.price;
        const compareAtPrice = selectedVariant.compare_at_price;
        const hasDiscount = compareAtPrice && compareAtPrice > price;

        const formatMoney = (cents) => `${(cents / 100).toFixed(2).replace('.', ',')}€`;

        const priceRegularEl = priceContainer.querySelector('[pdp-price-regular]');
        const priceSaleEl = priceContainer.querySelector('[pdp-price-sale]');
        const priceItemSaleEl = priceContainer.querySelector('[pdp-price-sale-current]');
        const compareAtPriceEl = priceContainer.querySelector('[pdp-price-compare]');
        const regularPriceEl = priceContainer.querySelector('[pdp-price]');

        priceRegularEl.toggleAttribute('hidden', hasDiscount);
        priceSaleEl.toggleAttribute('hidden', !hasDiscount);

        if (hasDiscount) {
            if (priceItemSaleEl) priceItemSaleEl.textContent = formatMoney(price);
            if (compareAtPriceEl) compareAtPriceEl.textContent = formatMoney(compareAtPrice);
        } else {
            if (regularPriceEl) regularPriceEl.textContent = formatMoney(price);
        }
    }

    //   actualiza selected option value name 
    updateOption1Legend() {
        const checkedInput = this.element.querySelector('input[data-pango-option-position="1"]:checked' );
        if (!checkedInput) return;
        const translated = checkedInput.dataset.pangoOptionValueTranslated;
        if (!translated) return;
        const label = this.element.querySelector('[p-pdp-options-1-legend]');
        if (!label) return;
        label.textContent = translated;
    }

    updateOption2Values() {
        const colorInput = this.element.querySelector('input[data-pango-option-position="1"]:checked');
        if (!colorInput) return;
        const selectedColor = colorInput.dataset.pangoOptionValue;
        const esconderColores = this.element.hasAttribute('esconder-colores-sin-tallas'); // metacampo ultima llamada

        const validVariants = this.variants.filter(v => v.options[0] === selectedColor && v.available);
        const availableSizes = [...new Set(validVariants.map(v => v.options[1]))];

        const option2Container = this.element.querySelector('[data-pango-option-wrapper="2"]');
        if (!option2Container) return;

        const previousOption2Value = option2Container.querySelector('input:checked')?.value; // talla que estaba selecionada

        option2Container.innerHTML = '';
        const allSizes = [...new Set(this.variants.filter(v => v.options[0] === selectedColor).map(v => v.options[1]))];
        allSizes.forEach(size => {
            const isAvailable = availableSizes.includes(size);
            if (esconderColores && !isAvailable) return; // ← si el atributo está presente, skip

            const label = document.createElement('label');
            label.innerHTML = `
                <input
                type="radio"
                name="option2"
                data-pango-option-position="2"
                data-pango-option-value="${size}"
                value="${size}"
                aria-label="${size}"
                ${isAvailable ? '' : 'aria-disabled="true"'}
                class="hidden"
                >
                <span class="p-talla">${size}</span>
            `;
            if (!isAvailable) label.classList.add('is-disabled');
            option2Container.appendChild(label);
        });

        this.attachOption2Listeners();
    }

    updateCardLinks(selectedVariant) {
        if (!this.card) return;
        
        const linkElements = this.card.querySelectorAll('[data-pango-current-variant-url]');
        if (!linkElements.length) return;

        linkElements.forEach(linkElement => {
            const url = new URL(linkElement.href);
            url.searchParams.set('variant', selectedVariant.id);
            linkElement.href = url.toString();
        });
    }

    // Precarga todas las imgs de option1 (main + hover) en background.
    // Se ejecuta solo una vez gracias al flag this._imagesPreloaded
    preloadOption1CardImages() {
        if (this._imagesPreloaded) return;
        this._imagesPreloaded = true;
        
        const inputs = this.element.querySelectorAll('[data-pango-option-position="1"]');
        inputs.forEach(input => {
            const main  = input.dataset.pangoOption1Img;
            const hover = input.dataset.pangoOption1ImgHover;
            
            if (main) {
                const img = new Image();
                img.src = main;
            }
            if (hover) {
                const img = new Image();
                img.src = hover;
            }
        });
    }

    // en Product card
    updateCardImages() {
        const colorInput = this.element.querySelector('input[data-pango-option-position="1"]:checked');
        const selectedColorImageUrl = colorInput.dataset.pangoOption1Img;
        const selectedColorHoverImageUrl = colorInput.dataset.pangoOption1ImgHover;
        if (!this.card) return;
        const img = this.card.querySelector('.p-card-gallery .p-card-img');
        if (!img) return;
        img.src = selectedColorImageUrl;
        img.srcset = selectedColorImageUrl;
        
        const imgHover = this.card.querySelector('.p-card-gallery .p-card-img-hover');
        if (!imgHover) return;
        if (selectedColorHoverImageUrl){
            imgHover.src = selectedColorHoverImageUrl;
            imgHover.srcset = selectedColorHoverImageUrl;
        } else {
            imgHover.src = selectedColorImageUrl;
            imgHover.srcset = selectedColorImageUrl;
        }
    }

    // ————————————————————————————————————————————————————————————————————————————————
    // Add to cart - open drawer - update drawer - update bubble
    handleSubmit(event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const id = this.variantIdInput.value;
        if (!id) return;

        const quantityInput = this.element.querySelector('input[name="quantity"]');
        const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ id, quantity })
        })
        .then(response => {
            if (!response.ok) throw new Error('Error adding to cart');
            return response.json();
        })
        .then(data => {
            document.dispatchEvent(new CartAddEvent({
                resource: data
            }));
            // Cerrar modal si está abierto
            const modal = document.getElementById('p-card-modal');
            if (modal && !modal.hasAttribute('hidden')) {
                modal.setAttribute('hidden', '');
                document.body.classList.remove('modal-open');
                modal.querySelector('.p-card-modal-content').innerHTML = '';
            }
        })
        .catch(error => console.error('Error:', error));
    }
}

// ————————————————————————————————————————————————————————————————————————————————
// START - inicializa todos los vriant picker , de PDP o Card
// ———————————————————————————————————————————————————————————————————————————————— 
function initCardVariantPickers() {
//   clg("initCardVariantPickers")
  const allCardVariantPickers = document.querySelectorAll('.p-variant-picker-card:not([data-pango-initialized])');
  allCardVariantPickers.forEach(card => {
    card.setAttribute('data-pango-initialized', 'true'); // marcamos para no reinicializar
    new CardVariantPickers(card);
  });
}
// ------------------------------
// inicializa On click filtros
// inicializa On elementos que renderizan cuando visibles: scroll infinito, related products, etc
// ------------------------------
const observer = new MutationObserver(() => {
  const uninitializedForms = document.querySelectorAll('.p-variant-picker-card:not([data-pango-initialized])');
  if (uninitializedForms.length > 0) {
    initCardVariantPickers();
  }
});

observer.observe(document.body, { childList: true, subtree: true });

// ------------------------------
// inicializa on Dom loaded
// ------------------------------
document.addEventListener('DOMContentLoaded', initCardVariantPickers);




// ————————————————————————————————————————————————————————————————————————————————
// MODAL ÚNICO PARA CARDS
// ————————————————————————————————————————————————————————————————————————————————
function initCardModal() {
    const modal = document.getElementById('p-card-modal');
    if (!modal) return;

    const modalContent = modal.querySelector('.p-card-modal-content');
    const closeBtn = modal.querySelector('.p-card-modal-close');
    const backdrop = modal.querySelector('.p-card-modal-backdrop');

    // Abrir modal
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[button-open-card-modal]');
        if (!trigger) return;

        const originalCard = trigger.closest('.p-card'); // ← .p-card en vez de form
        if (!originalCard) return;

        const clone = originalCard.cloneNode(true);

        // Reinicializar el form dentro del clon
        const cloneForm = clone.querySelector('.p-variant-picker-card');
        if (cloneForm) {
            cloneForm.setAttribute('data-pango-initialized', 'true'); // ← antes del appendChild
        }

        modalContent.innerHTML = '';
        modalContent.appendChild(clone); // ← observer dispara aquí, ya está marcado

        if (cloneForm) {
            new CardVariantPickers(cloneForm); // ← después
        }

        modalContent.innerHTML = '';
        modalContent.appendChild(clone);

        modal.removeAttribute('hidden');
        document.body.classList.add('modal-open');
    });

    // Cerrar
    function closeModal() {
        modal.setAttribute('hidden', '');
        document.body.classList.remove('modal-open');
        modalContent.innerHTML = '';
    }

    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeModal();
    });
}

document.addEventListener('DOMContentLoaded', initCardModal);